import { Box, Button, Menu, MenuItem } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React, { useCallback, useMemo, useState } from "react";
import { getUnconditionalName } from "./Conditional/HelpersConditional";
import { gamePiecePropertyInfo } from "./HelpersGamePieceProperty";
import { useTreeModifyContext } from "./TreeDataContext";
import { usePathContext } from "./PathInfo";

interface GamePieceFooterProps {
  gamePieceName: string;
  data: any;
}

export function GamePieceFooter(props: GamePieceFooterProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { saveChangesAtPath } = useTreeModifyContext();
  const { path } = usePathContext();
  const open = Boolean(anchorEl);

  const handleClose = useCallback(
    (property?: string) => {
      setAnchorEl(null);

      if (property) {
        let newProperties = Object.assign({}, props.data);
        newProperties[property] = gamePiecePropertyInfo[property].defaultValue;
        saveChangesAtPath(newProperties, path);
      }
    },
    [path, props.data, saveChangesAtPath],
  );

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const getAllMissingProperties = useCallback(() => {
    let propertiesPresent: string[] = [];

    {
      Object.keys(props.data).map((propName) => {
        let unconditionalName = getUnconditionalName(propName);
        if (!propertiesPresent.includes(unconditionalName)) {
          propertiesPresent.push(unconditionalName);
        }
      });
    }

    let allPossibleProperties = Object.keys(gamePiecePropertyInfo);

    return allPossibleProperties.filter((possibleProperty) => !propertiesPresent.includes(possibleProperty));
  }, [props.data]);

  const hasAnyMissingProperties = useMemo(() => {
    return getAllMissingProperties().length > 0;
  }, [getAllMissingProperties]);

  return (
    <Box className="horizontal-flex">
      <Box className="flex-filler"></Box>
      <Box style={{ padding: "5px" }}>
        {hasAnyMissingProperties && (
          <Button
            id="add property button"
            aria-controls={open ? "add property menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            color="success"
            size="large"
            endIcon={<AddBoxIcon />}
          >
            Add property
          </Button>
        )}
        {open && (
          <Menu open={open} onClose={() => handleClose()} anchorEl={anchorEl} disableScrollLock={true}>
            {getAllMissingProperties().map((property) => (
              <MenuItem key={property} onClick={() => handleClose(property)} disableRipple>
                {property}
              </MenuItem>
            ))}
          </Menu>
        )}
      </Box>
      <Box className="flex-filler"></Box>
    </Box>
  );
}
